exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-5f96618a] {\n  background: rgba(235, 244, 255, var(--bg-opacity));\n}\n.overflow[data-v-5f96618a] {\n  text-overflow: ellipsis;\n  width: 15em;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.unread[data-v-5f96618a] {\n  border-right: 3px solid #38b2ac;\n}\n", ""]);

// exports
